export default __webpack_public_path__ + "static/media/icn-finances.5aa99961.svg";